export function getMonthInterval(expired) {
    if (!expired) return "N/A"; 

    const now = new Date();
    const activeDate = new Date(expired);

    let yearDiff = now.getFullYear() - activeDate.getFullYear();
    let monthDiff = now.getMonth() - activeDate.getMonth();
    let dayDiff = now.getDate() - activeDate.getDate();

    let totalMonths = yearDiff * 12 + monthDiff;

    // Koreksi jika tanggal expired lebih besar dari hari ini dalam bulan yang sama
    if (dayDiff < 0) {
        totalMonths -= 1;
    }

    return -totalMonths; // Selalu negatif jika expired sudah lewat
}
